import { render, staticRenderFns } from "./_base-spinner.vue?vue&type=template&id=e5d06fd2&scoped=true&"
import script from "./_base-spinner.vue?vue&type=script&lang=js&"
export * from "./_base-spinner.vue?vue&type=script&lang=js&"
import style0 from "./_base-spinner.vue?vue&type=style&index=0&id=e5d06fd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d06fd2",
  null
  
)

export default component.exports